// extracted by extract-css-chunks-webpack-plugin
module.exports = {"table":"app-components-usersong-rightsholderstable--table","modified":"app-components-usersong-rightsholderstable--modified"};